import React, {useEffect, useState} from 'react';
import axios from 'axios';
import classNames from 'classnames';
import ClickableAnswer from './ClickableAnswer';
import iconBotImg from '../../../assets/img/icon-bot.png';
import iconUserImg from '../../../assets/img/icon-user.png';
import useMessages from '../../../hooks/useMessages';
import replace from '../../../helpers/markdownReplacer';
import useLanguage from "../../../hooks/useLanguage";
import {localizedContent} from "../../../utils";


/**
 * The complete Triforce, or one or more components of the Triforce.
 * @typedef {Object} IntentAnswer
 * @property {boolean} bot - Indicates whether bot or user sent this
 * @property {array} answers - An array of answers (can also contain only one answer)
 * @property {Object} sourceIntent - Optional
 */

const AnswersBlock = ({ message }) => {
  const { bot, answers, sourceIntent } = message;

  const [disabled, setIsDisabled] = useState(false);

  const { addMessage, showForm } = useMessages();

  const { language } = useLanguage();


  useEffect(( ) => {
    if(hasForm()){
      showForm();
    }
  }, []);

  // handle on click for any of the messages in this block
  const onClick = async (answer) => {

    // we no longer allow to be clicked on any of the buttons in this message
    // setIsDisabled(true);

    // first add a message what the user just said
    const userMessage = {
      bot: false,
      answers: [{
        ...answer,
        followUpAction: 'ANSWER'
      }],
    };
    await addMessage(userMessage);

    // check for the followUpAction
    if(answer.followUpAction === "INTENT") {
      // make request for followup data of this option
      const { data } = await axios.get(`/intent/${answer.followUpIntentId}`);

      if(data.intent?.answers?.length !== 0){
          await addMessage({
            bot: true,
            answers: data.intent.answers
          })
      }
    }
  };

  const hasForm = () => {
    return answers.find((answer) => answer.followUpAction === 'FORM' );
  }
  const hasLinks = () => {
    return answers.find((answer) => answer.followUpAction === 'LINK' )
  }

  const textMessages = () => {
    return Array.isArray(answers) ? answers.filter((answer) => answer.followUpAction === 'ANSWER' || answer.followUpAction === 'FORM' || answer.followUpAction === 'CHAT') : [];
  }

  const notTextMessages = () => {
    return Array.isArray(answers) ? answers.filter((answer) => answer.followUpAction !== 'ANSWER' && answer.followUpAction !== 'FORM'  && answer.followUpAction !== 'CHAT') : [];
  }

  const renderMessages = () => {
    const messages = notTextMessages();
    if (!messages || messages.length === 0) {
      return;
    }

    let i = 0;

    return messages.map((answer) => {
      i++;
      if (answer.followUpAction === 'LINK') {
        return <div className="option-link" key={`answer-${i}`}
                    dangerouslySetInnerHTML={{ __html: replace(localizedContent(answer, language)) }} />;
      }

      return (
        <ClickableAnswer key={`answer-${i}`} answer={answer} disabled={disabled} onClick={onClick} />
      );
    });
  };

  return (
    <>
      <div className={
        classNames({
          'message-wrapper': true,
          bot,
        })
      }>

        <div className={
          classNames({
            icon: true,
            bot,
          })
        }>
          <img src={bot ? iconBotImg : iconUserImg} alt="" />
          {!bot && <div className="letter">F</div>}
        </div>
        <div className={
          classNames({
            messages: true,
            bot,
          })
        }>
          {(textMessages()).map((textMessage, index) => {
            return <div key={index} className={
              classNames({
                message: true,
                bot,
              })
            }>
              <div dangerouslySetInnerHTML={{ __html: replace(localizedContent(textMessage,language)) }} />
            </div>
          })}
          {notTextMessages() && notTextMessages().length > 0 && !hasLinks() && (
              <div className="inner-options">
                {renderMessages()}
              </div>
          )}
          {notTextMessages() && notTextMessages().length > 0 && hasLinks() && (
              <div className="inner-options without-border">
                {renderMessages()}
              </div>
          )}
        </div>
      </div>

    </>
  );
};

export default AnswersBlock;
